import * as AuthTypes from 'core/logic/authentication/auth.types'

export const getPlatformfromProviderId = (provider: string) => {
  if (provider.startsWith('google')) return AuthTypes.Platform.gmail
  else if (provider.startsWith('facebook')) return AuthTypes.Platform.facebook
  else return
}

export const firestoreTimestamp = {
  createdAt<T extends object>(obj: T) {
    return {
      ...obj,
      createdAt: new Date(),
    }
  },
}
